<template>
  <div class="no-authority">
    <div class="error-icon">
      <i class="el-icon-close"></i>
    </div>
    <div class="error-text">{{ loginCode === 4001 ? '您申请的权限，还没有审批通过，请联系管理员！' : '您的帐号无查看权限，请申请权限或联系管理员进行开通！' }}</div>
    <div class="apply-btn" @click="toApply" v-if="loginCode === 4002">申请权限</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      routerQuery: {},
      loginCode: ''
    }
  },
  methods: {
    toApply () {
      this.$router.push({
        name: 'applyAuthority',
        query: this.$route.query
      })
    }
  },
  created () {
    const query = JSON.parse(JSON.stringify(this.$route.query))
    this.loginCode = parseInt(this.$route.query.loginCode)
    this.$delete(query, 'loginCode')
    this.routerQuery = query
  }
}
</script>

<style lang="stylus" scoped>
.no-authority
  width 100vw
  height calc(100vh - 150px)
  background #fff
  padding-top 150px
.error-icon
  width 60px
  height 60px
  line-height 60px
  text-align center
  font-size 40px
  border 2px solid #fc4c02
  border-radius 100%
  color #fc4c02
  margin 0 auto 20px
.error-text
  text-align center
  font-size 16px
  color #666
  line-height 20px
  width 80%
  margin 0 auto
.apply-btn
  height 45px
  line-height 45px
  width calc(100% - 40px)
  max-width 400px
  background #fc4c02
  margin 50px auto 0
  border-radius 5px
  text-align center
  font-size 14px
  color #fff
</style>
